import { createRouter, createWebHistory } from 'vue-router';
import { useRoute } from 'vue-router';
import store from './store'; // Assuming store is using Vuex

/*
|-------------------------------------------------------------------------------
| routes.js
|-------------------------------------------------------------------------------
| Contains all of the routes for the application
*/

// Import your components here
import BrandLayout from "@/js/ordercircle/brands/layouts/BrandLayout.vue";
import ShopLayout from "@/js/ordercircle/brands/layouts/ShopLayout.vue";
import AdminLayout from "@/js/ordercircle/admin/AdminLayout.vue";
import CustomerDetail from '@/js/ordercircle/brands/customers/detail.vue';
import AuthAPIService from '@/js/api/auth/auth';
import DashboardAPIService from '@/js/api/dashboard/dashboard'

// import NProgress from 'vue-nprogress'
// import swal from "sweetalert2";

// Vue.use(NProgress);

function parseJwt(token) {
  const base64 = token.split('.')[1];        // get payload part
  const decoded = atob(base64);              // decode base64
  return JSON.parse(decoded);                // parse to object
}
/*
  Determines where we should send the user.
*/
function requireAuth(to, from, next) {
    const route = useRoute();

    if (store.state.role !== "") {
        if (
            store.state.permissions.includes(to.meta.permission) &&
            to.meta.roles.includes(store.state.role)
        ) {
            next();
        }else if(to.meta.permission == "" && to.meta.roles.includes(store.state.role)){
            next()
        }
        else {
            safetyRoute(next, route);
        }
    } else {
        next("/");
    }
}

function safetyRoute(next, to) {
    let safetyRoute = "dashboard";
    if (to.path.includes("/shop/")) {
        safetyRoute = "shop";
    }
    window.Swal.fire({
        title: "Restricted Area",
        text: "You don't have sufficient permissions to access it.",
        icon: "warning",
        confirmButtonText: "Move to Dashboard?"
    }).then(function(result) {
        if (result.value) {
            next({ name: safetyRoute });
        }
    });
}

/*
|-------------------------------------------------------------------------------
| routes section
|-------------------------------------------------------------------------------
*/
const routes = [
    {
        path: '/stripe/redirect',
        name: 'stripe-redirect',
        component: () => import("@/js/ordercircle/brands/settings/StripeRedirect.vue"),
        props: true
    },
    {
        path: '/square/success',
        name: 'square-success',
        component: () => import("@/js/ordercircle/payments/square/squareSuccess.vue"),
        props: true
    },
    {
        path: '/xero/auth/callback',
        name: 'xero-redirect',
        component: () => import("@/js/ordercircle/integration/xero/XeroRedirect.vue"),
        props: true
    },
    {
        path: '/shopify/success',
        name: 'shopify-success',
        component: () => import("@/js/ordercircle/integration/shopify/ShopifySuccess.vue"),
        props: true
    },
    {
        name: "login",
        path: "/",
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/brands/update-login.vue"
            )
    },
    {
        path: '/reset-password/:token/:id/:username',
        name: 'ResetPassword',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/brand/reset-password.vue"
            ),
    },
    {
        path: '/add-payment/:customToken',
        name: 'stripe-public-payment-page',
        component: () => import('@/js/ordercircle/payments/PublicPaymentPage.vue'),
        meta: { public: true }
    },
    {
        path: '/admin/login',
        name: 'adminLogin',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/admin/admin-login.vue"
            ),
    },
    {
        path: '/login',
        name: 'reminderLogin',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/admin/reminder.vue"
            ),
    },
    {
            path: '/quickbooks/success',
            name: 'quickbooksSuccess',
            component: () => import("@/js/ordercircle/integration/QuickbooksSuccess.vue"),
            props: true
            // props: (route) => ({ query: route.query })
        },
    {
            path: '/hubspot/success',
            name: 'hubspotSuccess',
            component: () => import("@/js/ordercircle/integration/HubspotSuccess.vue"),
            props: true
        },

    {
        path: '/signup',
        name: 'adminsignup',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/admin/signup.vue"
            ),
    },
    {
        path: '/post-signup',
        name: 'postSignup',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/admin/postSignup.vue"
            ),
    },
    {
        path: '/change-password',
        name: 'changePassword',
        component: () =>
            import (
                /* webpackChunkName: "LOGIN" */
                "./ordercircle/auth/component/brand/change-password.vue"
            ),
    },
     {
        path: '/orders/packing-slips/:OrderNumber',
        name: 'packing-slips',
        component: () => import("@/js/ordercircle/invoices/views/packing-slips.vue"),

    },
     {
        path: '/orders/:OrderNumber/packing-slip/:shipmentNumber',
        name: 'shipment-packing-slip',
        component: () => import("@/js/ordercircle/invoices/views/shipment-packing-slip.vue"),

    },
    {
        path: '/orders/export-orders-to-pdf/:OrderNumber',
        name: 'export-orders-to-pdf',
        component: () => import("@/js/ordercircle/invoices/views/export-orders-to-pdf.vue"),

    },
     {
        path: '/OrderDraft/customer/:customer_id/order/:OrderNumber/InvoiceDraft',
        name: 'draft-order',
        component: () => import("@/js/ordercircle/invoices/views/draft-order.vue"),

    }, 
     {
        path: '/staff/:staffMemberId/commissionsInvoice/:showYear/:showMonthNum/:startDay?',
        name: 'draft-commission',
        component: () => import("@/js/ordercircle/invoices/views/draft-commission.vue"),
    }, 
     {
        path: '/staff/commissionsInvoice/:showYear/:showMonthNum/:startDay?',
        name: 'draft-commission-owner',
        component: () => import("@/js/ordercircle/invoices/views/draft-commission-owner.vue"),

    }, 
    {
    path: '/orders/pack-list/:OrderNumber',
    name: 'pick-list-view',
    component: () => import("@/js/ordercircle/invoices/views/pick-list.vue"),
    },

    {
    name: "invoice-pdf",
    path: "/:customer_id/invoices/:OrderNumber",
    component: () =>
        import (
            "@/js/ordercircle/invoices/views/invoice.vue"
        ),
    props: true,
    beforeEnter: requireAuth,
    meta: {
        permission: "manage_order", // Or a more specific permission if needed
        roles: ["admin", "owner", "staff"]
    }
    },

    {
        path: '/orders/invoice/:OrderNumber',
        name: 'multiple-invoices',
        props: true,
        component: () => import("@/js/ordercircle/invoices/views/combine-invoice.vue"),
    },
    {
        path: '/quickbooks/connect',
        name: 'quickbooks',
        component: () => import("@/js/ordercircle/integration/quickbooks.vue"),

    },
    {
        path: '/xero/auth/authorize',
        name: 'xeroConnect',
        component: () => import("@/js/ordercircle/integration/xero.vue"),

    },
    {
        path: "/payment-not-connected",
        component: () =>
            import (
                /* webpackChunkName: "shop" */
                "./ordercircle/brands/store/payment-not-connected.vue"
            ),
        meta: {
            roles: ["customer-contact"]
        }
    },
    {
        path: '/oauth/consent',
        name: 'OAuthConsent',
        component: () =>
            import(
                /* webpackChunkName: "AUTH" */
                "./ordercircle/brands/settings/ConsentScreen.vue"
            ),
    },
   {
        path: "/dashboard",
        component: BrandLayout,
        children: [
            /* ************************************ DASHBOARD ***************************************************/
            {
                path: '/dashboard/settings/api-settings',
                name: 'API-Keys',
                component: () =>
                    import(
                        /* webpackChunkName: "AUTH" */
                        "./ordercircle/brands/settings/oauth/api-settings.vue"
                    ),
            },
            {
                name: "xero-connect-callback",
                path: "/dashboard/xero-connect-callback",
                component: () =>
                    import (
                        /* webpackChunkName: "xero" */
                        "./ordercircle/integration/xero/XeroCallback.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner"]
                }
            },
            {
                name: "shopify-redirect",
                path: "/dashboard/shopify/redirect",
                component: () =>
                    import (
                        /* webpackChunkName: "shopify" */
                        "./ordercircle/integration/shopify/ShopifyRedirect.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner"]
                }
            },
            {
                name: "dashboard",
                path: "",
                component: () =>
                    import (
                        /* webpackChunkName: "dashboard" */
                        "./ordercircle/brands/dashboard/Dashboard.vue"
                    )
            },
            

            {
                name: "commissions-month",
                path: "/dashboard/commissions/:year/:month",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/dashboard/commission-detail.vue"
                    )
            },
            /* ************************************ ORDERS ***************************************************/
            {
                name: "order-list",
                path: "/dashboard/orders",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "archive-order-list",
                path: "/dashboard/orders/archive/:archive",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/list.vue"
                    ),
                beforeEnter: requireAuth,
                props: true,
                meta: {
                    showProgressBar: false,
                    permission: "manage_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "create-order",
                path: "/dashboard/orders/create",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "edit-order",
                path: "/dashboard/customers/:customer_id/orders/:OrderNumber/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "edit_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "view-order",
                path: "/dashboard/customers/:customer_id/orders/:OrderNumber",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/view-order.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "export",
                path: "/dashboard/orders/export",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/export.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "export_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            /**
             *  Purchase Orders Start
             */
            {
                name: "purchase-orders",
                path: "/dashboard/orders/purchase-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "purchase orders" */
                        "./ordercircle/brands/orders/purchase-orders/list.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "purchase_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "create-purchase-orders",
                path: "/dashboard/orders/purchase-orders/create",
                component: () =>
                    import (
                        /* webpackChunkName: "purchase orders" */
                        "./ordercircle/brands/orders/purchase-orders/create.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "purchase_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "view-purchase-order",
                path: "/dashboard/orders/purchase-orders/:PurchaseOrderNumber",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/purchase-orders/view.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "purchase_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "edit-purchase-order",
                path: "/dashboard/orders/purchase-orders/:PurchaseOrderNumber/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/purchase-orders/edit.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "purchase_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "no-vendors",
                path: "/dashboard/orders/purchase-orders/no-vendors",
                component: () =>
                    import (
                        /* webpackChunkName: "purchase orders" */
                        "./ordercircle/brands/orders/purchase-orders/no-vendors.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "purchase_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                // name: 'approveOrder',
                path: "/dashboard/customers/:customer_id/orders/:OrderNumber/approve",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/view-order.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "approve_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "reorder-admin",
                path: "/dashboard/customers/:customer_id/orders/:OrderNumber/reorder",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "admin-customer-order",
                path: "/dashboard/customer/:customer_id/orders",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_order",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            /* ************************************ CUSTOMERS ***************************************************/
            {
                name: "pending-customers-list",
                path: "/dashboard/customers/pending",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/pending-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_customer",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "pending-customer-detail",
                path: "/dashboard/customers/pending/:id",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/view-pending-customer.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_customer",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "brand-customer-create",
                path: "/dashboard/customers/create",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_customer",
                    roles: ["owner", "admin", "staff"] // list of allowed roles.
                }
            },
            {
                name: "brand-customers-list",
                path: "/dashboard/customers",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_customer",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "brand-edit-customer",
                path: "/dashboard/customers/:id/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/edit.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "update_customer",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/customers/import-export",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/import-export.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "import_export_customer",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/customers-import-status",
                component: () =>
                    import(
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/import-status.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "import_export_customer",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "brand-customer-detail",
                path: "/dashboard/customers/:id",
                component: () =>
                    import (
                        /* webpackChunkName: "customers" */
                        "./ordercircle/brands/customers/detail.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "view_customers",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            /* ************************************ PRODUCTS/PRICE TIERS *****************************************/
            {
                name: "createproduct",
                path: "/dashboard/products/create",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/add-new-product.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/products",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/products-list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/products-sorting",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/products-sorting.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_product",
                    roles: ["admin", "owner"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/products/import-export",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/import-export.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "importexport_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/products/import-status",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/import-status.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "importexport_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "view-product",
                path: "/dashboard/products/:id",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/view-product.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "view_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "edit-product",
                path: "/dashboard/products/:id/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/edit-product.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "update_product",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/price-tiers",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/price-tiers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "price_tiers",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/volume-price-tiers",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/volume-price-tiers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "price_tiers",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            // /* ************************************ PRODUCTS Collection *****************************************/
            {
                path: "/dashboard/product-collections",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/product-collection/product-collections.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
                // beforeEnter: requireAuth,
                // meta: {
                //     permission: 'manage_product',
                //     roles: ['admin', 'owner', 'staff'], // list of allowed roles.
                // },
            },
            {
                path: "/dashboard/product-collection/create",
                component: () =>
                    import (
                        /*webpackChunkName: "products"*/
                        "./ordercircle/brands/products/product-collection/create-product-collection.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "edit-product-collection",
                path: "/dashboard/product-collection/:id/edit",
                component: () =>
                    import (
                        /*webpackChunkName: "products"*/
                        "./ordercircle/brands/products/product-collection/edit-product-collection.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "product-collection-detail",
                path: "/dashboard/product-collection/:id",
                component: () =>
                    import (
                        /* webpackChunkName: "products" */
                        "./ordercircle/brands/products/product-collection/view-product-collection.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },

            // /* ************************************ STAFF *******************************************************/
            {
                path: "/dashboard/staff/create",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/members/create-staff.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/staff",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/members/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "staff_edit",
                path: "/dashboard/staff/:id/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/members/edit-staff.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/staff/roles",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/roles/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/staff/role/new",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/roles/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {   name: "edit-role",
                path: "/dashboard/staff/role/edit/:id",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/roles/edit.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/staff/commission-list",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/commission-list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "commissions-month-detail",
                path: "/dashboard/staff/:staffMemberId/commissions/:year/:month",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/commissions-month.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "commissions-month-without-id",
                path: "/dashboard/staff/commissions/:year/:month",
                component: () =>
                    import (
                        /* webpackChunkName: "staff" */
                        "./ordercircle/brands/staff/commissions-month.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name : 'owner-settings',
                path: "/dashboard/settings/account",
                component: () =>
                    import (
                        /* webpackChunkName: "owner" */
                        "./ordercircle/brands/owner/account/settings.vue"
                    )
            },
            {
                path: "/dashboard/shopify/misc-settings", //TODO Shopify is not connected
                component: () =>
                    import (
                        /* webpackChunkName: "shopify" */
                        "./ordercircle/brands/shopify/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/shopify/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "shopify" */
                        "./ordercircle/brands/shopify/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            // // Shopify App Welcome Page
            {
                path: "/dashboard/shopify-signup",
                component: () =>
                    import (
                        /* webpackChunkName: "shopify signup" */
                        "./ordercircle/brands/shopify/shopify-welcome-steps.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/misc-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/sync-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/sync-orders.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/link-products",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/link-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/link-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/link-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/sync-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/sync-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/quickbooks/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/quickbooks/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/hubspot/sync-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "hubspot" */
                        "./ordercircle/brands/hubspot/sync-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/hubspot/link-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "hubspot" */
                        "./ordercircle/brands/hubspot/link-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/odoo/link-products",
                component: () =>
                    import (
                        "./ordercircle/brands/odoo/link-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/odoo/link-customers",
                component: () =>
                    import (
                        "./ordercircle/brands/odoo/link-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/odoo/sync-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "odoo" */
                        "./ordercircle/brands/odoo/sync-orders.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/odoo/sync-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "odoo" */
                        "./ordercircle/brands/odoo/sync-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/odoo/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "odoo" */
                        "./ordercircle/brands/odoo/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/cin7/misc-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                path: "/dashboard/cin7/sync-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/sync-orders.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                path: "/dashboard/cin7/link-products",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/link-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                path: "/dashboard/cin7/link-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/link-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                path: "/dashboard/cin7/sync-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/sync-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                path: "/dashboard/cin7/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "cin7" */
                        "./ordercircle/brands/cin7/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            /* ************************************ Documents *******************************************************/
            {
                name: "documents",
                path: "/dashboard/documents",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/documents/brand-file-documents.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_documents",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            /* ************************************ Settings *******************************************************/
            {
                name: "shipment-methods",
                path: "/dashboard/settings/shipment_methods_settings",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/shipment_methods_settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "misc-settings",
                path: "/dashboard/settings/misc_settings",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/misc_settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "brand-info",
                path: "/dashboard/settings/brand_info",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/brand_info.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "brand-payments-settings",
                path: "/dashboard/settings/payments",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/payments.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "stripe-connect-callback",
                path: "/dashboard/stripe-connect-callback",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/StripeConnectCallback.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "square-callback",
                path: "/dashboard/square/callback",
                component: () =>
                    import (
                        /* webpackChunkName: "square callback" */
                        "./ordercircle/payments/square/squareCallback.vue"
                    ),
                    beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "brand-subscription-settings",
                path: "/dashboard/settings/subscription",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/subscription.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            // /* ************************************ Categories *******************************************************/
            {
                name: "brand-categories-create",
                path: "/dashboard/categories/create",
                component: () =>
                    import (
                        /* webpackChunkName: "categories" */
                        "./ordercircle/brands/categories/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_category",
                    roles: ["owner", "admin", "staff"] // list of allowed roles.
                }
            },
            {
                name: "brand-categories-list",
                path: "/dashboard/categories",
                component: () =>
                    import (
                        /* webpackChunkName: "categories" */
                        "./ordercircle/brands/categories/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_category",
                    roles: ["owner", "admin", "staff"] // list of allowed roles.
                }
            },
            // {
            //     name: "brand-categories-list-tree",
            //     path: "/dashboard/categories/tree-view",
            //     component: () =>
            //         import (
            //             /* webpackChunkName: "categories" */
            //             "./ordercircle/brands/categories/list-tree-view.vue"
            //         ),
            //     beforeEnter: requireAuth,
            //     meta: {
            //         permission: "manage_category",
            //         roles: ["owner", "admin", "staff"] // list of allowed roles.
            //     }
            // },
            {
                name: "brand-categories-edit",
                path: "/dashboard/categories/:categoryId/edit",
                component: () =>
                    import (
                        /* webpackChunkName: "categories" */
                        "./ordercircle/brands/categories/edit.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_category",
                    roles: ["owner", "admin", "staff"] // list of allowed roles.
                }
            },
            {
                name: "integrations",
                path: "/dashboard/integrations",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/integrations/index.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "woocommerceRedirect",
                path: "/woocommerce/auth/redirect",
                component: () =>
                    import(
                        /* webpackChunkName: "settings" */
                        "@/js/ordercircle/brands/integrations/woocommerceRedirect.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"]
                }
            },
            {
                name: "coming-soon",
                path: "/dashboard/settings/coming_soon",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/coming_soon.vue"
                    )
            },
            {
                name: "signup-form",
                path: "/dashboard/settings/signup-form",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/signup-form.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "brand-promo-codes",
                path: "/dashboard/settings/brand-promo-codes",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/brand-promo-codes.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "vendors",
                path: "/dashboard/settings/vendors",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/vendors.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "currency",
                path: "/dashboard/settings/currency",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/currency.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "user-profile",
                path: "/dashboard/profile",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/users/add-users.vue"
                    )
            },
            {
                name: "custom-layout",
                path: "/dashboard/settings/custom-layout",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/custom-layout.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "dashboad-type",
                path: "/dashboard/settings/custom-layout/dashboard-tab",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/custom-layout/dashboard-tab.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/shipstation/misc-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "shipstation" */
                        "./ordercircle/brands/shipstation/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/shipstation/sync-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "shipstation" */
                        "./ordercircle/brands/shipstation/sync-orders.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/shipstation/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "shipstation" */
                        "./ordercircle/brands/shipstation/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/settings/store",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/settings/store-settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/changeLogs",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/changelogs/index.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner"] // list of allowed roles.
                }
            },
            /*   ----------------Reports Routes----------------  */
            {
                path: "/dashboard/reports",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/index.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sale-by-sku-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sale-by-sku-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sale-by-sku-price-tiers-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sale-by-sku-price-tiers-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sale-by-customer-by-sku-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sale-by-customer-by-sku-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sale-by-customer-and-price-tiers",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-by-customer-and-price-tiers-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/total-outstanding-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/total-outstanding-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/staff-commission-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/staff-commission-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/staff-commission-on-profit-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/staff-commission-on-order-profit.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/rep-customers-relation-report",
                component: () =>
                    import (
                        "./ordercircle/brands/reports/rep-customers-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/accounts-receivable-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/accounts-receivable-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/accounts-receivable-aging-detail-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/accounts-receivable-aging-detail-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/orders-detail-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/orders-detail-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-inventory-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-inventory-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-by-parent-sku-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-by-parent-sku-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/products-total-custom-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/products-total-custom-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-rep-product-sales-report",
                component: () =>
                    import(
                        "./ordercircle/brands/reports/sales-rep-product-sales-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            // {
            //     path: "/dashboard/reports/allur-spa-custom-commission",
            //     component: () =>
            //         import (
            //             /* webpackChunkName: "settings" */
            //             "./ordercircle/brands/reports/custom-commission-report.vue"
            //         ),
            //     beforeEnter: requireAuth,
            //     meta: {
            //         permission: "show_reports",
            //         roles: ["admin", "owner", "staff"] // list of allowed roles.
            //     }
            // },
            {
              path: "/dashboard/ai-reports/inventory-forecast-report",
              component: () =>
                  import (
                      /* webpackChunkName: "settings" */
                      "./ordercircle/brands/reports/ai/inventory-forecast-report.vue"
                  ),
              beforeEnter: requireAuth,
              meta: {
                  permission: "show_reports",
                  roles: ["admin", "owner", "staff"] // list of allowed roles.
              }
          },
            {
                path: "/dashboard/reports/products-custom-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/products-custom-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/products-by-sku-and-customers-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/products-by-sku-and-customers-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-by-customer-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-by-customer-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/sales-by-customer-monthly-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/sales-by-customer-monthly-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/order-payments-details-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/order-payments-details-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/order-refund-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/order-refund-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/customer-activity-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/customer-activity-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/order-return-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/order-return-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/order-shipment-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/order-shipment-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/brand-customers-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/brand-customers-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/open-purchase-order-detail-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/open-purchase-order-detail-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/brand-customers-notes",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/brand-customers-notes.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/total-staff-commission-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/total-staff-commission-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/inventory-on-hand-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/inventory-on-hand-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/revenue-by-shipped-products",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/revenue-by-shipped-products-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/reports/order-sales-report",
                component: () =>
                    import (
                        /* webpackChunkName: "settings" */
                        "./ordercircle/brands/reports/order-sales-report.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_reports",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
              path: "/dashboard/reports/revenue-profit-report",
              component: () =>
                  import (
                      /* webpackChunkName: "settings" */
                      "./ordercircle/brands/reports/revenue-profit-report.vue"
                  ),
              beforeEnter: requireAuth,
              meta: {
                  permission: "show_reports",
                  roles: ["admin", "owner", "staff"] // list of allowed roles.
              }
            },
            {
              path: "/dashboard/reports/total-revenue-profit-comparison-report",
              component: () =>
                  import (
                      /* webpackChunkName: "settings" */
                      "./ordercircle/brands/reports/total-revenue-profit-comparison-report.vue"
                  ),
              beforeEnter: requireAuth,
              meta: {
                  permission: "show_reports",
                  roles: ["admin", "owner", "staff"] // list of allowed roles.
              }
            },
            {
                path: "/dashboard/xero/link-customers",
                component: () =>
                    import (
                        /* webpackChunkName: "xero" */
                        "./ordercircle/brands/xero/link-customers.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/xero/link-products",
                name: "xero-products",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/xero/link-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/xero/sync-orders",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/xero/sync-orders.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/xero/misc-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/xero/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                name: "search",
                path: "/dashboard/search/:query/:page?",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/Search/search-component.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "notifications",
                path: "/dashboard/notifications",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/notifications/list.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
            {
                name: "create-referrals",
                path: "/dashboard/referrals/create",
                component: () =>
                    import (
                        /* webpackChunkName: "quickbooks" */
                        "./ordercircle/brands/referrals/create.vue"
                    )
            },
            {
                path: "/dashboard/woocommerce/sync-products",
                component: () =>
                    import (
                        /* webpackChunkName: "woocommerce" */
                        "./ordercircle/brands/woocommerce/sync-products.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            {
                path: "/dashboard/woocommerce/misc-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "woocommerce" */
                        "./ordercircle/brands/woocommerce/settings.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "",
                    roles: ["owner", "admin"] // list of allowed roles.
                }
            },
            /* ************************************ Warehouse *******************************************************/
            {
                name: "multi-warehouse",
                path: "/dashboard/multi-warehouse",
                component: () =>
                    import (
                        /* webpackChunkName: "warehouse" */
                        "./ordercircle/brands/multi-warehouse/multi-warehouse.vue"
                    ),
            },
            // /* ************************************ Product Meta Fields *******************************************************/
            {
                name: "product-meta-fields",
                path: "/dashboard/settings/product-meta-fields",
                component: () =>
                    import (
                        /* webpackChunkName: "Product Meta Fields" */
                        "./ordercircle/brands/settings/product-meta-fields.vue"
                    ),
            },
        ]
    },
    {
        path: "/shop",
        component: ShopLayout,
        children: [
            /* ************************************ Shop Page ***************************************************/
            {
                name: "shop",
                path: "/shop",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/shop.vue"
                    ),
                meta: {
                    roles: ["customer-contact"] // list of allowed roles.
                }
            },
            {
                path: "/shop/orders",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/list.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_order",
                    roles: ["customer-contact"] // list of allowed roles.
                }
            },
            {
                path: "/shop/orders/create",
                name: "customer-create-order",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_order",
                    roles: ["customer-contact"], // list of allowed roles.
                    hideCartComponent: true
                }
            },
            {
                path: "/shop/brand-info",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/brand-info/show-brand-info.vue"
                    ),
                meta: {
                    roles: ["customer-contact"]
                }
            },
            {
                path: "/shop/setting/account",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/settings/setting.vue"
                    ),
                meta: {
                    roles: ["customer-contact"]
                }
            },
            {
                path: "/shop/documents",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/documents/document.vue"
                    ),
                meta: {
                    roles: ["customer-contact"]
                }
            },
            {
                name: "view-order-shop",
                path: "/shop/orders/:OrderNumber",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/view-order.vue"
                    ),
                props: true,
                beforeEnter: requireAuth,
                meta: {
                    permission: "manage_order",
                    roles: ["customer-contact"]
                }
            },
            {
                path: "/shop/payment-info",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/payment-info.vue"
                    ),
                meta: {
                    roles: ["customer-contact"]
                }
            },
            {
                name: "reorder-customer",
                path: "/shop/orders/:OrderNumber/reorder",
                component: () =>
                    import (
                        /* webpackChunkName: "orders" */
                        "./ordercircle/brands/orders/create.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "create_order",
                    roles: ["customer-contact"] // list of allowed roles.
                }
            },
            {
                name: "Referal",
                path: "/shop/referrals/create",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/referrals/create.vue"
                    ),
                meta: {
                    roles: ["customer-contact"] // list of allowed roles.
                }
            },
            {
                path: "/shop/contact",
                component: () =>
                    import (
                        /* webpackChunkName: "shop" */
                        "./ordercircle/brands/store/documents/contact-us.vue"
                    ),
                meta: {
                    roles: ["customer-contact"]
                }
            },
        ]
    },
    {
        path: "/dashboard_shopify",
        component: BrandLayout,
        children: [
            /* ************************************ DASHBOARD ***************************************************/

            {
                name: "dashboard-shopify",
                path: "",
                component: () =>
                    import (
                        /* webpackChunkName: "dashboard" */
                        "./ordercircle/brands/dashboard/shopify-dashboard.vue"
                    )
            },
        ]
    },
{
    path: "/admin",
    component: AdminLayout,
    children: [
        /* ************************************ Admin Page ***************************************************/
        {
            name: "admin",
            path: "/brand-list",
            component: () =>
                import (
                    /* webpackChunkName: "admin" */
                    "./ordercircle/admin/brands/list.vue"
                )
        },
        {
            name: "brands",
            path: "/admin/brands",
            component: () =>
                import (
                    /* webpackChunkName: "admin" */
                    "./ordercircle/admin/brands/list.vue"
                )
        },
        {
            name: "search-brands",
            path: "/admin/search-brands",
            component: () =>
                import (
                    /* webpackChunkName: "admin" */
                    "./ordercircle/admin/brands/search.vue"
                )
        },
            {
                name: "brand-detail",
                path: "/admin/brands/:subdomain",
                component: () =>
                    import (
                        /* webpackChunkName: "admin" */
                        "./ordercircle/admin/brands/detail.vue"
                    )
            },
            {
                name: 'plans',
                path: '/admin/plans',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/manage-plans/plans.vue'),
            },
            {
                name: 'CreatePlan',
                path: '/admin/plans/create',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/manage-plans/create-plan.vue'),
            },
            {
                name: 'features',
                path: '/admin/features',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/manage-plans/features.vue'),
            },
            {
                name: "changelogs",
                path: "/admin/changelogs",
                component: () =>
                    import (
                        /* webpackChunkName: "admin" */
                        "./ordercircle/admin/changelogs/index.vue"
                    )
            },
            {
                name: 'ocMigrations',
                path: '/admin/oc-migrations',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/oc-migrations/index.vue'),
            },
            {
                name: 'reports',
                path: '/admin/reports',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/reports/index.vue'),
            },
            {
                name: 'last-login-report',
                path: '/admin/reports/last-login-report',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/reports/last-login.vue'),
            },
            {
                name: 'last-order-report',
                path: '/admin/reports/last-order-report',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/admin/reports/last-order.vue'),
            },
            {
                name: 'brands-activity-report',
                path: '/admin/reports/brands-activity-report',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ './ordercircle/brands/reports/brands-activity-report.vue'),
            },
            {
                name: 'admin.knowledge-base',
                path: '/admin/knowledge-base',
                component: () =>
                    import ( /* webpackChunkName: "admin" */ '@/js/ordercircle/admin/knowledge-base/index.vue'),
            }
        ]
    },
    /* ************************************ ERROR HANDLER *******************************************************/
    {
        path: '/:pathMatch(.*)*',
        component: () =>
            import (
                /* webpackChunkName: "error-handler" */
                "./ordercircle/brands/error/404.vue"
            )
    },
    /* ************************************ Brand Document Copy URL *******************************************************/
    {
                name: "brandFileDownload",
                path: "/brand/show/:brand_id/:file_id/:download",
                component: () =>
                    import(
                        /* webpackChunkName: "settings" */
                        "@/js/ordercircle/brands/documents/brand-file-download.vue"
                    ),
                beforeEnter: requireAuth,
                meta: {
                    permission: "show_documents",
                    roles: ["admin", "owner", "staff"] // list of allowed roles.
                }
            },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkExactActiveClass: "kt-menu__item--active"
});

router.beforeEach(async (to, from, next) => {
    const queryParams = to.query; // Access query parameters using to.query
    const token = store.state.user.bearerToken; // Access Token
    const domain = window.location.hostname.split(".")[0]; //Access Domain
        if (domain === "admin") {
        document.title = "Admin - Portal";
        } 
    // Check if the subdomain with token coming from impersonate admin to brand is present
    // check if the subdomain with path and type coming from shopify store is present
    if (queryParams?.type === 'shopify_login' && queryParams?.token && queryParams?.subdomain) {
        const token = queryParams.token;
        const payload = parseJwt(token);
        const userId  = payload.sub;
        window.history.replaceState({}, '', window.location.pathname);
        store.commit('SHOW_LOADER', true);
    
        try {
            const response = await AuthAPIService.autoLogin({ user_id: userId });

            if (response.data.success === true) {
                store.dispatch('getData', response.data);
                store.commit('SET_PERMISSIONS', response.data.permissions);
                store.commit('SET_INTEGRATIONS', response.data.integration);

                if (response.data.user_role === 'staff') {
                    store.commit('REMEMBER_ROLE', response.data.user.username);
                }

                const skinResponse = await DashboardAPIService.getBrandSkins(response.data.token);
                store.commit('SHOW_LOADER', false);
                if (skinResponse.data.success) {
                    store.commit('SET_BRAND_SKIN_LIST', skinResponse.data.brandSkin);
                    
                    window.location.href = "/dashboard_shopify";
                }
            }
        } catch (error) {
        store.commit('SHOW_LOADER', false);
        window.Swal.fire({
            title: "Error!",
            text: "Auto login failed",
            icon: "error",
            confirmButtonText: "OK"
        });
        }
    }
    if (
        (queryParams?.subdomain && queryParams?.token) ||
        (queryParams?.subdomain && queryParams?.path && queryParams?.type)
    ) {
        return next();
    }

      // Helper for included paths 
    const allowedIncludes = [
            "/quickbooks/success",
            "/hubspot/success",
            "/stripe/redirect",
            "/xero/auth/callback",
            "/square/success",
            "/add-payment",
        ];
    const isIncludedPath = allowedIncludes.some(path => to.fullPath.includes(path));
    if (
        to.fullPath !== "/" &&
        to.name !== "ResetPassword" &&
        Object.keys(queryParams).length === 0
    ) {
        if (!token) {
            const isPublicRoute =
                to.fullPath === "/login" ||
                to.fullPath === "/signup" ||
                to.fullPath === "/post-signup" ||
                isIncludedPath;

            if (isPublicRoute) {
                return next();
            }

            if (domain === "admin") {
                if (to.fullPath === "/admin/login") {
                    return next(); // Allow access to admin login without token
                } else {
                    return next("/admin/login"); // Redirect to admin login for other admin routes
                }
            } else if (domain === "app") {
                return next("/login"); // Redirect to app login for other app routes
            } else {
                return next("/"); // Redirect to login for other domains
            }
        }
        else{
            // we fixed multiple tab issue if we are on brand  side and if one tab redirect to shop its changed the role and if we reload the remaining tab then 
            // it should redirect to shop 
            if(to.fullPath.includes("/dashboard") && store.state.role === "customer-contact") {
                return next("/shop");
            }
            // we fixed multiple tab issue if we are on shop  side and if one tab redirect to dashboard its changed the role and if we reload the remaining tab then
            //  it should redirect to brand ... we add a check of shopify because we have shopify routes in shopify side and shopify string contain shop
            else if(to.fullPath.includes("/shop") && !to.fullPath.includes("/shopify") && ['admin','owner','staff'].includes(store.state.role)) {
                return next('/dashboard');
            }
            else if(to.fullPath=='/change-password'){
                return next()
            }
            // if logged in user hit the /login path i.e /login path is the app route
            else if(to.fullPath=='/login'){
                return next('/dashboard')
            }
        }
    }
    if (to.fullPath === "/") {
        if (token) {
          if (domain === "admin") {
            return next("/admin/brands");
          }
          return next("/dashboard");
        } else {
          if (domain === "admin") {
            return next("/admin/login"); //Redirect to admin login routes if have token
          } else if (domain === "app") {
            return next("/login"); // Redirect to app login for other app routes
          }else{
            return next(); // Redirect to login for other domains
          }
        }
    }
 
    return next();
});

export default router;
